export default __webpack_public_path__ + "static/media/gallery-2.f86b41ab.jpg";